import {
    Component,
    OnInit,
    Input,
    ElementRef,
    AfterViewInit,
    ChangeDetectorRef,
    SimpleChanges,
    OnChanges
} from '@angular/core';

@Component({
    selector: 'app-review-table',
    templateUrl: './review-table.component.html',
    styleUrls: ['./review-table.component.scss'],
    standalone: false
})
export class ReviewTableComponent implements OnInit, AfterViewInit, OnChanges {
    @Input()
    reviewData: number[];

    public data: { name: string; value: number }[];

    view: any[] = [, 125];

    colorScheme = {
        domain: ['var(--app-primary)']
    };

    constructor(
        private el: ElementRef,
        private cd: ChangeDetectorRef
    ) { }

    onSelect(data): void { }

    onActivate(data): void { }

    onDeactivate(data): void { }

    ngAfterViewInit(): void {
        this.view[0] = this.el.nativeElement.parentElement.offsetWidth;
        this.cd.detectChanges();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.setData();
    }

    ngOnInit() {
        this.setData();
    }

    getAllReviewsValue(): string {
        if (!this.reviewData || this.reviewData.length === 0) {
            return '0';
        }

        const total = this.reviewData.reduce((sum, count) => sum + count, 0);
        return total.toLocaleString('de-DE');
    }

    getPercentage(value: number): string {
        if (!this.reviewData || this.reviewData.length === 0) {
            return '0.0';
        }

        const total = this.reviewData.reduce((sum, count) => sum + count, 0);
        const percentage = total > 0 ? (value / total * 100) : 0;
        const formattedPercentage = percentage % 1 === 0 ?
            percentage.toFixed(0) :
            percentage.toFixed(1).replace('.', ',');
        return formattedPercentage;
    }

    private setData(): void {
        if (!this.reviewData || this.reviewData.length === 0) {
            this.data = [];
            return;
        }

        this.data = [];
        for (let i = 5; i > 0; i--) {
            this.data.push({ name: '' + i, value: this.reviewData[i - 1] });
        }
    }

    getRatings(): number[] {
        return [5, 4, 3, 2, 1];
    }

    getStars(): number[] {
        return [1, 2, 3, 4, 5];
    }
}
